import script from "./MentionTeammateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MentionTeammateDialog.vue?vue&type=script&setup=true&lang=js"

import "./MentionTeammateDialog.vue?vue&type=style&index=0&id=055d2036&lang=scss&scoped=true"
import "./MentionTeammateDialog.vue?vue&type=style&index=1&id=055d2036&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055d2036"]])

export default __exports__